import { observer } from 'mobx-react-lite'
import { useTranslation } from 'next-i18next'
import { useStore } from '@/store/index'
import useLangPrefix from '@/hooks/useLangPrefix'
import { Announcement } from '@gate/gui'
import { eventTracker } from '@/utils/collectEvent'
import { PriceAnnItemStyled } from './style'

const PriceAnn = () => {
  const { bottomPriceAnn } = useStore().baseStore
  const { t } = useTranslation()

  const { langPrefix } = useLangPrefix()

  return (
    <>
      {bottomPriceAnn?.length ? (
        <Announcement
          messages={bottomPriceAnn?.map(item => (
            <PriceAnnItemStyled
              href={`${langPrefix}/article/${item?.index_ann_id}`}
              target="_blank"
              className="size-16 font-500 text-2"
              key={item?.index_ann_id}
              onClick={() => {
                eventTracker('price_sectors_click', {
                  announcement_url: `${langPrefix}/article/${item?.index_ann_id}`,
                })
              }}
            >
              {t('P.NoticeMassage', { massage: item?.index_ann ?? '--' })}
            </PriceAnnItemStyled>
          ))}
          showNum={bottomPriceAnn?.length}
          rightSectionOnClick={() => {
            eventTracker('price_sectors_click', {
              button_name: 'announcement_more',
            })
            window.open(`${langPrefix}/articlelist/ann`, '_blank')
          }}
        />
      ) : null}
    </>
  )
}

export default observer(PriceAnn)
